var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33335 2.64062C8.94025 2.64062 10.5155 2.77599 12.0484 3.03593C12.3593 3.08864 12.5833 3.3602 12.5833 3.67547V4.28447C12.5833 4.63257 12.445 4.96641 12.1989 5.21255L9.03024 8.3812C8.78409 8.62734 8.64581 8.96118 8.64581 9.30928V11.017C8.64581 11.5141 8.36494 11.9686 7.92028 12.1909L6.02081 13.1406V9.30928C6.02081 8.96118 5.88253 8.62734 5.63639 8.3812L2.46774 5.21255C2.22159 4.96641 2.08331 4.63257 2.08331 4.28447V3.67548C2.08331 3.36021 2.30736 3.08866 2.61819 3.03594C4.15111 2.77599 5.72642 2.64062 7.33335 2.64062Z",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.8a17a2d0a499e4cdea5ccf089a01354a.svg";
export { ForwardRef as ReactComponent };